
import BRadioGroup from 'JS/components/blain-form/BRadioGroup.vue';
import ChangeStoreSideMenu from 'JS/components/side-menus/change-store/ChangeStoreSideMenu.vue';
import FulfillmentOptionLink from './FulfillmentOptionLink.vue';
import FulfillmentOptionsFooterDelivery from './FulfillmentOptionsFooterDelivery.vue';
import FulfillmentOptionsFooterPickup from './FulfillmentOptionsFooterPickup.vue';
import FulfillmentOptionsFooterShipping from './FulfillmentOptionsFooterShipping.vue';
import InStorePickup from './InStorePickup.vue';
import LocalDelivery from './LocalDelivery.vue';
import StandardShipping from './StandardShipping.vue';
import StockSubscriptionForm from './StockSubscriptionForm.vue';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { FulfillmentType } from '../../../types/ProductDelivery';
import { Get } from 'vuex-pathify';
import { ILocalStoreJson } from 'src/js/types/LocalStore';
import { IProductDetailProductJson } from '../../../types/PDP';

@Component({
	name: 'FulfillmentOptions',
	components: {
		BRadioGroup,
		LocalDelivery,
		InStorePickup,
		StandardShipping,
		ChangeStoreSideMenu,
		FulfillmentOptionsFooterShipping,
		FulfillmentOptionsFooterPickup,
		FulfillmentOptionsFooterDelivery,
		StockSubscriptionForm,
		FulfillmentOptionLink
	}
})
export default class FulfillmentOptions extends Vue {
	@Prop({ type: Boolean, required: false, default: false })
	readonly loading: boolean;

	/* Computed
	============================================*/

	@Get('product')
	readonly product: IProductDetailProductJson;

	@Get('localStore')
	readonly localStore: ILocalStoreJson;

	@Get('currentZip')
	readonly currentZip: string;

	@Get('fulfillmentType')
	readonly fulfillmentType: FulfillmentType;

	@Get('quantity')
	readonly quantity: number;

	@Get('showTopLevelBackInStockForm')
	readonly showTopLevelBackInStockForm: boolean;

	@Get('customerEmail')
	readonly customerEmail: string | null;

	get remainingSelectors() {
		return this.$store.getters.remainingSelectors;
	}

	get hasRemainingSelectors(): boolean {
		return this.remainingSelectors?.length > 0;
	}

	get isLocalDeliveryAvailable(): boolean {
		return this.product.activeLocalDelivery && this.localStore?.localDeliveryInformation?.isEnabled;
	};
	
	get stockFormDescription(): string | null {
		if (!this.showTopLevelBackInStockForm) {
			return null;
		}

		const prefix = this.product.nearestInStock ? "Or, sign" : "Sign";
		return `${prefix} up to receive an email when this item is back in stock.`;
	}

	/* Data
	============================================*/
	showChangeStore = false;
	selectedFulfillmentType = '';

	onMounted() {
		this.selectedFulfillmentType = this.fulfillmentType;
	}

	
	@Watch('fulfillmentType')
	onFulfillmentTypeChange(type: FulfillmentType) {
		this.selectedFulfillmentType = type;
	}

	/* Methods
	============================================*/
	handleStoreChanged() {
		if (typeof window !== 'undefined') {
			const url = `${window.location.origin}${window.location.pathname}?fulfillment_type=${this.fulfillmentType}`;
			window.history.replaceState({}, document.title, url);
			window.location.reload();
		}
	}

	setDeliveryType(type: FulfillmentType) {
		this.$store.dispatch('setDeliveryType', 
			{ fulfillmentType: type, allowDisabledOptions: true });
	}
}
